import { Col, notification, Row } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import arquivoExemplo from '../../../assets/files/LoteIntegracao.csv';
import SpinDot from '../../../components/SpinDot';
import SubHeader from '../../../components/SubHeader';
import { showErrors } from '../../../helpers/form';
import {
  removeMoedaMask,
  removeThousandSeparatorMask,
} from '../../../helpers/formatador';
import apiShipper from '../../../services/apiShipper';
import TarifaTmovContext from './contexts/TarifaTmovContext';
import { calculaFreteInicial } from './helpers/calculos';
import {
  extrairPedagioRota,
  getIdCidades,
  getPedagioRota,
} from './helpers/cidades';
import { validarCidadesOrigemDestino } from './helpers/validators';
import ListagemCsv from './ListagemCsv';
import ModalFrete from './Modal/modalFrete';
import {
  Button,
  Card,
  Divider,
  DownloadLink,
  SubTitle,
  Upload,
  UploadButton,
} from './styles';

export default function CadastroLote() {
  const history = useHistory();
  const [file, setFile] = useState({});
  const [dadosCsv, setDadosCsv] = useState([]);
  const [dadosCalcularFrete, setDadosCalcularFrete] = useState([]);
  const [showModalSelecaoFrete, setShowModalSelecaoFrete] = useState(false);
  const [showTable, setShowTable] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false);
  const [calcularFretes, setCalcularFretes] = useState(false);
  const [disabledBtnEnviar, setDisabledBtnEnviar] = useState(true);
  const [tarifaTmov, setTarifaTmov] = useState({});
  useContext(TarifaTmovContext);

  const breadcrumbs = [
    {
      path: '/lotes',
      breadcrumbName: 'Lotes',
    },
    {
      breadcrumbName: 'Cadastro via CSV',
    },
  ];

  useEffect(() => {
    if (!dadosCsv.length) {
      setShowTable(false);
    }

    setDisabledBtnEnviar(
      dadosCsv.some(dadoCsv => Object.values(dadoCsv.errors).length > 0)
    );
  }, [dadosCsv]);

  useEffect(() => {
    async function calcularFrete() {
      if (!calcularFretes) return;

      const dadosFreteCalculado = dadosCalcularFrete.map(dadoFrete => ({
        ...dadoFrete,
        freteMotorista:
          dadoFrete.freteInserido === 'freteMotorista'
            ? dadoFrete.freteMotorista
            : 0,
        freteTotal:
          dadoFrete.freteInserido === 'freteTotal' ? dadoFrete.freteTotal : 0,
      }));

      setDadosCsv(await calculaFreteInicial(dadosFreteCalculado));

      setShowTable(true);
      setLoading(false);
    }

    calcularFrete();
  }, [calcularFretes, dadosCalcularFrete]);

  const updateDadosCsv = async lotesIntegracao => {
    setLoading(true);
    setShowModalSelecaoFrete(false);
    setDadosCalcularFrete(lotesIntegracao);
    setCalcularFretes(true);
  };

  const handleUpload = async ({ file: uploadedFile }) => {
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append('file', uploadedFile);

      let selecionarTipoFrete = false;
      const idCidadesOrigemDestino = [];
      const { data } = await apiShipper.post(
        '/lotes-integracao/valida-csv',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      data.forEach(loteIntegracao => {
        const idCidades = getIdCidades(loteIntegracao);

        if (
          idCidades.idCidadeOrigem !== null &&
          idCidades.idCidadeDestino !== null &&
          !validarCidadesOrigemDestino(idCidadesOrigemDestino, idCidades)
        ) {
          idCidadesOrigemDestino.push(idCidades);
        }
      });

      setTarifaTmov(data[0].tarifaTmov);

      const { data: pedagios } = idCidadesOrigemDestino.length
        ? await getPedagioRota(idCidadesOrigemDestino)
        : { data: [] };

      const lotesIntegracao = data.map(loteIntegracao => {
        loteIntegracao.icms = 0;
        loteIntegracao.pedagio = extrairPedagioRota(
          pedagios,
          getIdCidades(loteIntegracao)
        );

        if (loteIntegracao.freteInserido === 'freteMotoristaTotal') {
          selecionarTipoFrete = true;
          loteIntegracao.freteInserido = 'freteMotorista';
        }

        return loteIntegracao;
      });

      setFile(uploadedFile);
      if (selecionarTipoFrete) {
        setDadosCalcularFrete(lotesIntegracao);
        setShowModalSelecaoFrete(true);
      } else {
        setDadosCsv(await calculaFreteInicial(lotesIntegracao));
        setShowTable(true);
      }
    } catch (e) {
      if (e.response && e.response.data) {
        const { message, errors } = e.response.data;
        showErrors(message, errors);
      } else {
        showErrors();
      }
    } finally {
      setLoading(false);
    }
  };

  const validarPedagioIncluso = (pedagio, pedagioIncluso) => {
    if (pedagio && pedagioIncluso === 'SIM') return 1;
    if (pedagio && pedagioIncluso === 'NÃO') return 3;
    return 2;
  };

  const handleSubmit = async () => {
    setLoadingButton(true);
    const lotesIntegracao = dadosCsv.map(dados => ({
      arquivo_integracao: dados.arquivoIntegracao,
      cliente_shipper_id: dados.idClienteRaiz,
      cliente_pagador_id: dados.idClientePagador,
      filial_id: dados.idFilial,
      especie_id: dados.idEspecie,
      produto_id: dados.idProduto,
      cliente_origem_id: dados.idClienteOrigem,
      cliente_destino_id: dados.idClienteDestino,
      cliente_expedidor_id: dados.idClienteColeta,
      cliente_recebedor_id: dados.idClienteEntrega,
      cidade_origem_id: dados.idCidadeOrigem,
      cidade_destino_id: dados.idCidadeDestino,
      cidade_expedidor_id: dados.idCidadeColeta,
      cidade_recebedor_id: dados.idCidadeEntrega,
      cliente_endereco_origem_id: dados.idClienteEnderecoOrigem,
      cliente_endereco_destino_id: dados.idClienteEnderecoDestino,
      cliente_endereco_expedidor_id: dados.idClienteEnderecoColeta,
      cliente_endereco_recebedor_id: dados.idClienteEnderecoEntrega,
      observacoes: dados.observacoes,
      data_inicio: dados.dataInicio,
      data_fim: dados.dataFim,
      volume: removeThousandSeparatorMask(dados.volume),
      cadencia: removeThousandSeparatorMask(dados.cadencia),
      base_frete_shipper:
        dados.freteInserido === 'freteMotorista' ? 'motorista' : 'total',
      frete_motorista:
        removeMoedaMask(dados.freteMotoristaPj || dados.freteMotoristaPf) || 0,
      frete_total:
        removeMoedaMask(dados.freteTotalPj || dados.freteTotalPf) || 0,
      frete_motorista_pf:
        removeMoedaMask(dados.freteMotoristaPf || dados.freteMotoristaPj) || 0,
      frete_total_pf:
        removeMoedaMask(dados.freteTotalPf || dados.freteTotalPj) || 0,
      pedagio_incluso: validarPedagioIncluso(
        dados.pedagio,
        dados.pedagioIncluso
      ),
    }));

    try {
      await apiShipper.post('/lotes-integracao', lotesIntegracao);
      setDadosCsv([]);
      setFile({});
      history.push('/demandas');
      notification.success({
        message: 'Seus lotes foram importados com sucesso',
        description:
          'Em poucos minutos serão integrados e estarão disponíveis a milhares de caminhoneiros no Brasil.',
      });
    } catch (e) {
      const { message, errors } = e.response.data;
      showErrors(message, errors);
    } finally {
      setLoadingButton(false);
    }
  };

  return (
    <>
      <TarifaTmovContext.Provider value={tarifaTmov}>
        <SubHeader breadcrumbs={breadcrumbs} />
        <Card bordered={false} className="pt-15 height-85">
          <Row justify="center" align="middle">
            {loading && (
              <SpinDot className="position-abs" message="Validando lotes..." />
            )}
            <Col span={24} className={`${loading && 'opacity01'}`}>
              <Row>
                <SubTitle>Envie apenas arquivos no formato .CSV</SubTitle>
                <Divider type="vertical" />
                <SubTitle>
                  Clique&nbsp;
                  <DownloadLink
                    href={arquivoExemplo}
                    target="_self"
                    download="lote-integracao.csv"
                  >
                    aqui
                  </DownloadLink>
                  &nbsp;para fazer o download do arquivo exemplo CSV.
                </SubTitle>
              </Row>
              <Upload
                name="fileUpload"
                accept=".csv"
                showUploadList={false}
                customRequest={handleUpload}
              >
                <Row justify="space-between">
                  <Col span={18}>
                    <UploadButton>
                      {file.name || 'Seu arquivo aqui'}
                    </UploadButton>
                  </Col>
                  <Col>
                    <Button>Escolher arquivo</Button>
                  </Col>
                </Row>
              </Upload>
              <Row>
                {showModalSelecaoFrete && (
                  <ModalFrete
                    lotesIntegracao={dadosCalcularFrete}
                    updateDadosCsv={updateDadosCsv}
                  />
                )}
                {showTable && (
                  <ListagemCsv dadosCsv={dadosCsv} setDadosCsv={setDadosCsv} />
                )}
              </Row>
              <Row justify="end" className="pt-15">
                <Button
                  onClick={handleSubmit}
                  disabled={disabledBtnEnviar}
                  borderradius="4px"
                  hidden={!dadosCsv.length}
                  loading={loadingButton}
                >
                  Enviar
                </Button>
              </Row>
            </Col>
          </Row>
        </Card>
      </TarifaTmovContext.Provider>
    </>
  );
}
